import {SearchQueryParams} from './search-query-params.model';
import {SearchOrder} from '../enums/search-order.enum';
import {FormState} from './form-state.model';

interface SearchListProps {
    items?: any[];
    loading?: boolean;
    error?: boolean;
    orderByField?: string;
    orderDirection?: SearchOrder;
    filters?: FormState;
}

export const SEARCH_REQUEST_PAGE_LIMIT = 100;

export class SearchList<T> {
    items: T[] = null;
    loading = false;
    error = false;
    queryParams: SearchQueryParams;

    constructor(props: SearchListProps = {}) {
        const {items = null, loading = false, error = false, orderByField, orderDirection, filters} = props;
        Object.assign(this, {
            items,
            loading,
            error,
            queryParams: {
                orderByField,
                orderDirection,
                filters
            }
        });
    }
}
